import React from "react";
import PropTypes from "prop-types";
import PubmedEntry from "./PubmedEntry";

function CommentScreen({ entry, onEntryUpdated }) {
  function updateComment(x) {
    entry.comment = x;
    onEntryUpdated(entry.clone());
  }

  return (
    <>
      <div className="tw-font-bold text-larger-3">4. Comments</div>

      <div className="tw-py-1">
        You can optionally add your comments to this entry. Please do not enter
        personally identifiable information for any individual.
      </div>

      <div className="varsome-typeahead">
        <textarea
          placeholder="Comment..."
          value={entry.comment}
          id="comment-area"
          className="focus:tw-border-primary tw-px-1 tw-py-1 tw-w-full tw-border tw-border-blueGray-300 tw-outline-none tw-flex-grow"
          onChange={(e) => updateComment(e.target.value)}
        />
      </div>
    </>
  );
}

CommentScreen.propTypes = {
  entry: PropTypes.instanceOf(PubmedEntry).isRequired,
  onEntryUpdated: PropTypes.func.isRequired,
};

export default CommentScreen;
